// OwnerLayout.js
import React, { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import OwnerSidebar from './OwnerSidebar';
import { OwnerContext } from '../../context/OwnerContext';
import TopNavBar from '../commons/TopNavBar';
import MobileOwnerSidebar from './MobileOwnerSidebar';
import '../../styles/TrainerLayout.css';

const OwnerLayout = ({ children }) => {
    const contextValue = useContext(OwnerContext);
    const location = useLocation();

    // Debug the context value
    console.log('OwnerLayout contextValue:', contextValue);
    console.log('OwnerLayout owner:', contextValue?.owner);

    // Safely extract owner from context
    const owner = contextValue?.owner || null;

    // Initialize state from localStorage or default to false
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
        const saved = localStorage.getItem('ownerSidebarCollapsed');
        return saved !== null ? JSON.parse(saved) : false;
    });

    // Save state to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('ownerSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
    }, [isSidebarCollapsed]);

    const toggleSidebarCollapse = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    // FIX: Extract userId properly - accept both string and number IDs
    // The previous check (typeof owner?.id === 'number') was too strict
    // and would fail if the ID came from an API as a string
    const userId = owner?.id ?? null;

    return (
        <div className={`layout-container ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
            {/* The desktop sidebar (hidden on small screens by CSS) */}
            <div className="sidebar">
                <OwnerSidebar
                    isCollapsed={isSidebarCollapsed}
                    onToggleCollapse={toggleSidebarCollapse}
                    activeRoute={location.pathname}
                />
            </div>

            {/* Mobile sidebar - the toggle button is now in TopNavBar */}
            <div className="mobile-sidebar-container">
                <MobileOwnerSidebar />
            </div>

            <div className="content">
                <TopNavBar pageTitle="Dashboard" userId={userId} />
                {children && typeof children === 'object' && !React.isValidElement(children)
                    ? React.Children.toArray(children)
                    : children}
            </div>
        </div>
    );
};

export default OwnerLayout;